// extracted by mini-css-extract-plugin
export var container = "_gn-1";
export var editor = "_gn-2";
export var resizable = "_gn-3";
export var wrapper = "_gn-0";